import Marquee from "react-fast-marquee";

const WORDS = [
  "Wine Tastings",
  "Winery Tours",
  "Social Evenings",
  "New Discoveries",
  "Local Friends",
  "Cellar Doors",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="relative border-y border-white/10 bg-wine-primary/40 py-6 md:py-8">
      <Marquee speed={28} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display italic text-3xl md:text-5xl text-cream/90">{w}</span>
            <span className="text-gold text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
